export default __webpack_public_path__ + "static/media/lp-new-backfit-trainer-desktop.fa1d148b.jpg";